import React from 'react';
import { useTranslation } from 'react-i18next';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import CommentIcon from '@wix/da-ds/pkg/Icons/Comment';
import { useReplyButtonBase } from './useReplyButtonBase';
import s from './ReplyButton.scss';

export interface Props {
  className?: string;
  disabled?: boolean;
}

const ReplyButton: React.FC<Props> = ({
  className,
  disabled: disabledOverride,
}) => {
  const { onClick, disabled } = useReplyButtonBase({
    disabledOverride,
  });
  const { t } = useTranslation();

  return (
    <PlainButtonOrLink
      className={className}
      onClick={onClick}
      disabled={disabled}
    >
      <span className={s['reply-with-icon']}>
        <CommentIcon className={s['reply-icon']} size={IconSize.SMALLER} />
        {t('comment.action.reply')}
      </span>
    </PlainButtonOrLink>
  );
};
ReplyButton.displayName = 'ReplyButton';

export default ReplyButton;
